import { DataBean } from "../DataBean";

export class PayrollConcepts extends DataBean {



    public async getPayrollConcepts(year: any, month: any, idPayrollType: any, valueType: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPayrollConcepts_Number_Number_Number_Number_String_Number_Number", [year, month, idPayrollType, valueType, regexStr, page, recordsPerPage]);
    }

}